module.exports = __webpack_public_path__ + "static/media/ico_btn_auteur.55e572fb.svg";